// Registriert alle Aktionstyp-Module auf der Default-Singleton-Registry (aktionsRegistry).
// Import-Nebenwirkung genügt — siehe lib/ki/erstelleTicketAusAnalyse.ts, das diese Datei
// nur wegen ihres Seiteneffekts importiert. stelleModuleSicher() existiert als expliziter
// Anker für Aufrufer, die den Import nicht "toter Code" nennen möchten.
import { aktionsRegistry } from './registry';
import { handwerkerBeauftragenModul } from './typen/handwerkerBeauftragen';
import { angebotAnfordernModul } from './typen/angebotAnfordern';
import { antwortAbsenderModul } from './typen/antwortAbsender';
import { anTeamModul } from './typen/anTeam';
import { wiedervorlageModul } from './typen/wiedervorlage';
import { interneAufgabeModul } from './typen/interneAufgabe';

[
  handwerkerBeauftragenModul,
  angebotAnfordernModul,
  antwortAbsenderModul,
  anTeamModul,
  wiedervorlageModul,
  interneAufgabeModul,
].forEach((m) => aktionsRegistry.registriere(m));

export function stelleModuleSicher(): void {}
